module.exports = __webpack_public_path__ + "img/75596.7cd58e2a.svg";